export default __webpack_public_path__ + "static/media/Oxford.7ae9faf6.png";